module.exports = __webpack_public_path__ + "assets/ic.9e4e9761.svg";